import { KeywordsSource } from '@/components/SearchPanel/components/SearchSuggestions.types';
import { QUERY, ROOT_CATEGORY_SLUG } from '@/constants/common';

export function buildViewAllResultsHref(keywords: string): string {
  const params = new URLSearchParams({
    [`${QUERY.q}[${QUERY.keywords}]`]: keywords,
    [QUERY.keywordsSource]: KeywordsSource.Typewritten,
  });
  return `/${ROOT_CATEGORY_SLUG}?${params.toString()}`;
}
